import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_32 } from '../../Button'
import { EntityProfileHeaderTitleToggleButton } from '../EntityProfileHeaderTitleToggleButton'

import * as styles from './EntityProfileHeaderTitleActions.module.css'

import EditIcon from '../../../icons/edit.svg'

function EntityProfileHeaderTitleActions({
  isArchived,
  isHeaderOpen,
  isHovered,
  isLoading,
  onClickEditTitleButton,
  onToggleHeader,
}) {
  const { t } = useTranslation()

  const editButtonClassName = classNames(styles.editButton, {
    [styles.hovered]: isHovered,
  })

  return (
    <>
      {isArchived || isLoading ? null : (
        <Button.Outlined
          isGrey
          beforeIconProps={{ Icon: EditIcon }}
          className={editButtonClassName}
          height={BUTTON_HEIGHT_32}
          tooltip={t('Profile.EditBtnKey')}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          onClick={onClickEditTitleButton}
        />
      )}
      <EntityProfileHeaderTitleToggleButton
        className={styles.titleItem}
        isOpen={isHeaderOpen}
        onClick={onToggleHeader}
      />
    </>
  )
}

export default EntityProfileHeaderTitleActions
